import React from 'react'
import { Card, CardContent } from '@/components/ui/card'
import { Package, Users } from 'lucide-react'
import { StockPoint } from '@/gen/branch/common_pb'
import { StockPointType } from '@/gen/auth/common_pb'

const StockPointCard = ({stockPoint}: {
  stockPoint: StockPoint
}) => {
  return (
    <Card className="border border-[#787878]">
      <CardContent className="p-4 space-y-2">
        <p
          className={`text-sm capitalize ${
            status === 'online' ? 'text-green-600' : 'text-red-500'
          }`}
        >
          {status}
        </p>
        <div>
          <h3 className="font-bold">{stockPoint.name}</h3>
          <p className="text-sm text-gray-500">{
              Object.keys(StockPointType).find(
                key => StockPointType[key as keyof typeof StockPointType] === stockPoint.stockPointType
              ) || 'Unknown Type'
            }</p>
        </div>
        <p className="text-xs text-gray-500">
          Manager: {stockPoint.managerName} | Shift Start Time: {stockPoint.shiftStartTime}
        </p>
        <div className="flex items-center gap-4 pt-2">
          <div className="flex items-center gap-2">
            <Users className="h-4 w-4" />
            <span className="text-sm text-gray-500">{stockPoint.totalUsersWithAccess} Members</span>
          </div>
          <div className="flex items-center gap-2">
            <Package className="h-4 w-4" />
            <span className="text-sm text-gray-500">{stockPoint.totalInventoryItems} Items</span>
          </div>
        </div>
      </CardContent>
    </Card>
  )
}

export default StockPointCard